import { mainTheme } from 'themes'
import { createMuiTheme } from '@material-ui/core/styles'
import './css/FontImport.css'
import { messagesTheme } from './sub-themes/messages/MessagesTheme.js'

// Do NOT add values that are not in the mainTheme. It will cause problems down the line. If something is missing add it to the main object then override it here.
const theme = JSON.parse(JSON.stringify(mainTheme))
theme.appName = 'My.Phone.com'
theme.favicon.default = '/icons/my-pdc-favicon.ico'
theme.favicon.unread = '/icons/my-pdc-favicon-unread.ico'

theme.messagesApp.app = messagesTheme

const myPdcTheme = createMuiTheme(theme)

/** @module my-pdc-theme */
/**
 * my pdc theme
 */
export { myPdcTheme }
